import { locationFactory } from '@rtls/core/models/location/location.factory';
import { typeFactory } from '@rtls/core/models/shared/type.factory';
import { stateFactory } from '@rtls/core/models/thing/state.factory';
import { Step } from '@rtls/core/models/thing/step.model';
import { thingSummaryFactory } from '@rtls/core/models/thing/thing-summary.factory';
import { nullable, randomDate, randomName, randomSentence } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const stepFactory = Factory.makeFactory<Step>({
	id: Factory.each((i) => nullable(i)),
	startDate: Factory.each(() => randomDate()),
	endDate: Factory.each(() => nullable(randomDate())),
	category: Factory.each(() => typeFactory.build()),

	story: Factory.each(() => randomName()),
	state: Factory.each(() => stateFactory.build()),
	storyTranslation: Factory.each(() => randomSentence()),
	storyKind: Factory.each(() => typeFactory.build()),
	thing: Factory.each(() => nullable(thingSummaryFactory.build())),
	location: Factory.each(() => nullable(locationFactory.build())),
});
